<template>
   <div class="container-fluid container-timeline">
    <div class="container" style="max-width: 1250px;">
      <div class="row justify-content-center">
        <div class="col-12 text-center text-white mt-3">
          <h2>Conoce la trayectoria de Fernando Valenzuela</h2>
        </div>
        <div class="col-12">
          <div class="container-timeline__items">
            <div class="d-none d-md-block container-timeline__line"></div>
            <ul class="d-none d-md-block">
              <li class="timeline-item d-md-inline" v-for="(item, ix) in timeline" :key="`desktop_${ix}`">
                <div class="col-item">
                  <span class="timeline-item__year">
                    <label>{{ item.anio }}</label>
                    <b-button class="btn-item d-none d-md-inline-block"  :id="`item_${ix}_${item.anio}`"></b-button>
                    <b-button class="btn-item d-inline-block d-md-none"></b-button>
                  </span>
                  <b-popover variant="black" :target="`item_${ix}_${item.anio}`" triggers="hover" placement="bottom">
                    <template #title>{{ item.anio }}</template>
                    <div class="timeline-item__description">
                      {{ item.description }}
                    </div>
                  </b-popover>
                </div>
                <div class="text-left text-white col-10 d-block d-md-none mb-3">
                  {{ item.description }}
                </div>
              </li>
            </ul>
            <ul class="d-block d-md-none">
              <li class="timeline-item d-md-inline" v-for="(item, ix) in timeline.slice(0,4)" :key="ix">
                <div class="col-item">
                  <span class="timeline-item__year">
                    <label>{{ item.anio }}</label>
                    <b-button class="btn-item d-none d-md-inline-block"  :id="`item_${ix}_${item.anio}`"></b-button>
                    <b-button class="btn-item d-inline-block d-md-none"></b-button>
                  </span>
                  <b-popover variant="black" :target="`item_${ix}_${item.anio}`" triggers="hover" placement="bottom">
                    <template #title>{{ item.anio }}</template>
                    <div class="timeline-item__description">
                      {{ item.description }}
                    </div>
                  </b-popover>
                </div>
                <div class="text-left text-white col-10 d-block d-md-none mb-3">
                  {{ item.description }}
                </div>
              </li>
            </ul>
            <b-collapse :visible="visible" id="collapse-1" class="d-md-none mt-2">
              <ul>
                <li class="timeline-item row" v-for="(item, ix) in timeline.slice(4,timeline.length)" :key="ix">
                  <div class="col-2 col-md-12 p-0">
                    <span class="timeline-item__year">
                      <label>{{ item.anio }}</label>
                      <b-button class="btn-item d-none d-md-block"  :id="`item_${ix}_${item.anio}`"></b-button>
                      <b-button class="btn-item d-inline-block d-md-none"></b-button>
                    </span>
                    <b-popover :target="`item_${ix}_${item.anio}`" triggers="hover" placement="bottom">
                      <template #title>{{ item.anio }}</template>
                      <div class="timeline-item__description">
                        {{ item.description }}
                      </div>
                    </b-popover>
                  </div>
                  <div class="text-left text-white col-10 d-block d-md-none mb-3">
                    {{ item.description }}
                  </div>
                  
                </li>
              </ul>
            </b-collapse>
            <div class="d-block d-md-none text-center border-top">
              <b-button @click="visible=!visible" class="text-white" variant="link">
                
                <span v-if="!visible" >Leer más <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/></svg></span> 
                <span v-if="visible" >Cerrar <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/></svg></span> 

              </b-button>
            </div>
            
          </div>
        </div>
        <div class="col-12 text-center d-block d-md-none">
          <div class="mb-5">
            <a href="https://www.ihop.com/en/" target="_blank"><img class="publiciti" src="/especiales/noticias/2023/fernandovalenzuela/images/banner320x50.jpg"/></a>
          </div>
        </div>
      </div>
    </div>
   </div>
  </template>

  <style lang="scss">

    .container-timeline {
      background: #000;
      .line {
        max-width: 620px;
        height: 1px;
        background: #e3e3e3;
        margin: 15px auto;
      }

      &__items {
        max-width: 1420px;
        position: relative;
        margin: 35px auto;
        z-index: 0;
      }

      &__line {
        position: absolute;
        bottom: 12px;
        width: 100%;
        height: 1px;
        background: #fff;
        z-index: 0;
      }

      h2 {
        font-weight: 700;
        font-size: 21px;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        text-align: center;
        z-index: 1;
        position: relative;
      }

      .timeline-item {
        display: inline;
        padding: 0 5px;

        @media(max-width: 560px){
          display: flex;
        }

        &:hover {
          transform: scale(1.5);

          @media(max-width: 560px){
            transform: scale(1) !important;
          }

          label {
            color: #f14037;
          }
        }

        .col-item {
          display: inline-block;
        }

        label {
          display: block;
          font-size: 16px;
          color: #fff;
          text-align: center;
          margin: 0;
        }

        .btn-item {
          display: block;
          border-radius: 50%;
          height: 25px;
          width: 25px;
          background-color: #f14037;
          border-color: #f14037;
          transition: transform .15s ease-in-out;
          z-index: 1;

          &:hover {
            background-color: #f14037;
            transform: scale(1.5);
          }
        }

        &__year {
          display: inline-block;
          margin: 0 5px;
          text-align: center;
        }
      }
    }
    
  </style>
  
  <script>
      export default {
    name: 'TimeLine',
    props: {
      msg: String
    },
    data() {
      return {
        visible: false
      }
    },
    computed: {
      timeline() {
        return require('@/data/timeline.json')
      }
    }
  }
  
  </script>